import React from 'react';
import PropTypes from 'prop-types';

import Context from './Context';

import PageTitleNew from '../../ui/PageTitleNew';
import Table from './Table';

export default function Index({ scope }) {
  return (
    <Context>
      <div className="wrapper_assestment invite_wrapper">
        <PageTitleNew title="Coach Delete" />

        <div className="ibox-content mt20">
          <Table scope={scope} />
        </div>
      </div>
    </Context>

  );
}

Index.propTypes = {
  scope: PropTypes.string.isRequired,
};
